import {
  DATASHEET_TYPES,
  EDatasheetFields,
  EDatasheetFieldsForEditComplex,
} from '../constants/datasheet'

type TDatasheet = { type: string; value: string }[]

const generateRegexKey = (key: string) => new RegExp(`\\b${key}\\b`, 'i')

export const findDatasheetItem = (datasheet: TDatasheet, key: string) => {
  return datasheet.find(item => generateRegexKey(key).test(item.type))
}

export const excludeDatasheetItem = (datasheet: TDatasheet, key: string) => {
  return datasheet.filter(item => !generateRegexKey(key).test(item.type))
}

export const excludeDatasheetRegulatoryItems = (datasheet: TDatasheet) => {
  return Object.values(EDatasheetFields).reduce((total, currentValue) => {
    return excludeDatasheetItem(total, currentValue)
  }, datasheet)
}

export const excludeDatasheetForEditComplexItems = (datasheet: TDatasheet) => {
  return Object.values(EDatasheetFieldsForEditComplex).reduce((total, currentValue) => {
    return excludeDatasheetItem(total, currentValue)
  }, datasheet)
}

const updateDatasheetItem = (datasheet: TDatasheet, key: string, value: string) => {
  const copy = [...datasheet]
  const item = findDatasheetItem(copy, key)

  if (item) {
    const idx = copy.indexOf(item)

    if (value) {
      copy[idx].value = value
      return copy
    }

    copy.splice(idx, 1)
    return copy
  }

  if (value) {
    const type = DATASHEET_TYPES[key]
    copy.push({ type, value })
  }

  return copy
}

const filterFilledDatasheetItems = (datasheet: TDatasheet) => {
  return datasheet.filter(item => !!item.value && !!item.type)
}

export const parseDatasheet = (datasheet: TDatasheet, values: Record<EDatasheetFields, string>) => {
  return Object.entries(values).reduce((total, [key, value]) => {
    return updateDatasheetItem(total, key, value)
  }, filterFilledDatasheetItems(datasheet))
}
